import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA]" data-testid="auth-checking">
        <Loader2 className="animate-spin text-black/60" size={22}/>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
